import { useMemo } from 'react';

type NullableString = string | null | undefined;

export const useCdnUrl = () => {
  const s3Prefix = 'https://guydeez-cms.s3.eu-west-3.amazonaws.com';
  // Mets ton domaine CDN dans une variable d'env pour pouvoir changer facilement
  const cloudFrontPrefix = process.env.NEXT_PUBLIC_IMG_CDN || 'https://d34x5tj5ipeog5.cloudfront.net';

  const toCdnUrl = useMemo(
    () => (urlOrPath: NullableString): string => {
      if (!urlOrPath) return '';
      if (urlOrPath.startsWith(s3Prefix)) {
        return urlOrPath.replace(s3Prefix, cloudFrontPrefix);
      }
      if (urlOrPath.startsWith('/')) {
        return cloudFrontPrefix + urlOrPath;
      }
      return urlOrPath;
    },
    [cloudFrontPrefix]
  );

  return toCdnUrl;
};
